import toast from "react-hot-toast";
import { create } from "zustand";
import { find, getAll } from "../services/service";
import { LIST_INTENTION } from "../Utils/constant";

export const useIntentionStore = create((set) => ({
  loading: false,
  data: [],
  getIntentionByInTime: async (url, statut) => {
    set({
      loading: true,
      data: [],
    });
    try {
      const intentions = await find(url);

      set({
        loading: false,
        data: statut === "" ? intentions.data : {
          data: intentions.data.data.filter((e) => e?.inTime === (statut === "true" ? true : false))
        },
      });
    } catch (error) {
      toast.error("Erreur de chargement des intentions");
      set({
        loading: false,
        data: [],
      });
    }
  },
  intentionList: async (param, otherParam) => {
    set({
      loading: true,
      data: [],
    });
    try {
      const intentions = await getAll(LIST_INTENTION, param, otherParam);
      set({
        loading: false,
        data: intentions.data,
      });
    } catch (error) {
      toast.error(error?.response?.data?.donnee);
      set({
        loading: false,
        data: [],
      });
    }
  },
  intentionListEnAttente: async (url, param, otherParam) => {
    set({
      loading: true,
      data: [],
    });
    try {
      const intentions = await getAll(url, param, otherParam);
      set({
        loading: false,
        data: intentions.data,
      });
    } catch (error) {
      set({
        loading: false,
        data: [],
      });
    }
  },
}));
